// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$String = require("rescript/lib/js/string.js");
var Js_json = require("rescript/lib/js/js_json.js");

function Make(Config) {
  var id_encode = function (id) {
    return id;
  };
  var id_decode = function (json) {
    var id = Js_json.decodeString(json);
    if (id !== undefined) {
      return {
              TAG: /* Ok */0,
              _0: id
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: {
                path: "",
                message: "Failed to decode " + Config.name,
                value: json
              }
            };
    }
  };
  var doesEqualStringId = function (stringId, id) {
    return id === stringId;
  };
  var cmp = $$String.compare;
  return {
          id_encode: id_encode,
          id_decode: id_decode,
          doesEqualStringId: doesEqualStringId,
          cmp: cmp
        };
}

exports.Make = Make;
/* No side effect */
